/********
 * Debounce function
 *
 * Returns a function, that, as long as it continues to be invoked, will not be triggered.
 * The function will be called after it stops being called for N milliseconds.
 * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
 *
 * Reference: https://davidwalsh.name/javascript-debounce-function
 ********/
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

var $ = jQuery;

$( document ).foundation();

$( window ).load( function() {
  /* Preloader */
  $( '.__preloader' ).fadeOut();
  $( 'body' ).removeClass( '__loading' );
} );

$( '.__date' ).flatpickr( {
  dateFormat: "d-m-Y",
  minDate: "today"
} );
$( '.__before_date' ).flatpickr( {
  dateFormat: "d-m-Y",
  maxDate: "today"
} );
$( '.__full_date' ).flatpickr( {
  dateFormat: "d-m-Y",
} );